// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__VJwSV","col":"styles_col__1awCJ"};